import { Box } from '@mui/material'

/**
 * Gaze-position marker overlaid on the stimulus player (eye-tracking studies).
 *
 * `x`/`y` are normalised screen coordinates (0..1, top-left origin) — the same
 * space the backend stores per frame on `eye_gaze_point`. The dot is positioned
 * as a percentage of the stage box, so it tracks where the respondent looked as
 * the video plays. A 30 ms CSS transition only bridges the ~30 Hz playhead
 * updates — any longer and the dot visibly trails the stimulus.
 *
 * Purely decorative: `pointerEvents: none` so it never intercepts clicks meant
 * for the player (play/pause, face-pip swap).
 */
export default function GazeDot({ x, y }: { x: number; y: number }) {
  const left = `${Math.max(0, Math.min(1, x)) * 100}%`
  const top = `${Math.max(0, Math.min(1, y)) * 100}%`
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        left,
        top,
        zIndex: 4,
        width: 12,
        height: 12,
        borderRadius: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        transition: 'left .03s linear, top .03s linear',
        // White point with a dark rim: readable on the red of the heat map and
        // on a dark stimulus alike (Z-118, wariant B bez pulsu).
        bgcolor: '#fff',
        border: '2px solid rgba(0, 0, 0, 0.6)',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.45)',
      }}
    />
  )
}
